import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { CompanyTypeInsertService } from '../../service/company-type-insert/company-type-insert.service';

@Component({
	selector: 'app-company-type-insert',
	templateUrl: './company-type-insert.component.html',
	providers: [
		CompanyTypeInsertService,
		HttpModule
	]
})
export class CompanyTypeInsertComponent implements OnInit {

	private token;
	companyType: FormGroup;
	Tipo: string = "";
	statusCompanyType: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private companyTypeInsertService: CompanyTypeInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.companyType = fb.group({
			'Tipo': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addCompanyType(value: any) {
		this.companyTypeInsertService.insertCompanyType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-empresa');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-empresa');
	}

}



// WEBPACK FOOTER //
// ./src/app/company-type/component/company-type-insert/company-type-insert.component.ts